import { createIcon } from './factory'
import Icon from './sign-out.svg?react'

export const SignOut = createIcon({ regular: Icon, bold: Icon, fill: Icon, duotone: Icon })
